import { createContext } from "react"

import type { AuthUser } from "@/types/auth.types"

export type AuthContextUser = AuthUser & {
  spokenLanguages?: string[]
  contributionLanguages?: string[]
  moderationLanguages?: string[]
  preferredLocale?: 'fr' | 'en'
  requiresLanguageSetup?: boolean
}

export type AuthContextValue = {
  user: AuthContextUser | null
  setUser: (user: AuthContextUser | null) => void
  logout: () => void
  isAuthenticated: boolean
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined)
